import createModel, { Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import {
  APIS,
  ShoppingInfo,
  ParamsBodyshopPostIncentivesUsingPost,
  CommonResult
} from '@src/services';
import { message } from 'antd';

export interface State {
  // @IMP: 保留askModel层级结构
  askModel: {
    userKcoinInfo: ShoppingInfo;
  };
}

export const askModelState: State = {
  askModel: {
    userKcoinInfo: {}
  }
};

const model = createModel({
  state: askModelState,
  namespace: 'askModel',
  reducers: {
    /** doSomething */
    setUserKcoinInfo: (state, action: Tction<{ userKcoinInfo: ShoppingInfo }>): typeof state => {
      const { userKcoinInfo } = action.payload;
      return {
        ...state,
        askModel: {
          ...state.askModel,
          userKcoinInfo
        }
      };
    }
  },
  effects: {
    /**
     * @description 个人账户信息
     */
    *getUserKcoinInfo({ tCall, tPut }): Iterator<{}, any, any> {
      // yield tPut(model.actions.changeLoading, { loading: action.payload.loading });
      const res: Utils.GetROA<typeof APIS.ShopApi.shopPersonalAccountUsingGet> = yield tCall(
        APIS.ShopApi.shopPersonalAccountUsingGet
      );
      const { code, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setUserKcoinInfo, { userKcoinInfo: result || {} });
      } else {
        message.error(res.message);
      }
    },
    /** 悬赏 */
    *coinIncentive(
      { tPut, tCall },
      action: Tction<{
        data: ParamsBodyshopPostIncentivesUsingPost;
        callBack?: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { data, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopPostIncentivesUsingPost> = yield tCall(
        APIS.ShopApi.shopPostIncentivesUsingPost,
        data
      );
      callBack && callBack(res);
    }
  }
});

/**
 * @description 全局Model askModel 挂载到 redux 上
 */
export default model;
